import { render, staticRenderFns } from "./RemotePage.vue?vue&type=template&id=4a81014e&scoped=true"
import script from "./RemotePage.vue?vue&type=script&lang=js"
export * from "./RemotePage.vue?vue&type=script&lang=js"
import style0 from "./RemotePage.vue?vue&type=style&index=0&id=4a81014e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a81014e",
  null
  
)

export default component.exports